import { R } from '@core/utils/r';
import { LabourTypeResponse, LabourTypeId } from '@business/entities/labour-type';
import { Endpoint } from '@business/api/endpoint';

export function fetchLabourTypes(isPublic?: boolean) {
  if (isPublic) return Endpoint.get<LabourTypeResponse[]>(`@gc/public/labour/type`);
  else return Endpoint.get<LabourTypeResponse[]>(`@gc/labour-type`);
}

export function createLabourType(data: Partial<LabourTypeResponse>) {
  return Endpoint.post<LabourTypeResponse>(`@gc/labour-type`, { data });
}

export function updateLabourType(categoryId: LabourTypeId, data: Partial<LabourTypeResponse>) {
  return Endpoint.patch<LabourTypeResponse>(`@gc/labour-type/${categoryId}`, { data });
}

export function deleteLabourType(categoryId: LabourTypeId) {
  return Endpoint.delete<void>(`@gc/labour-type/${categoryId}`);
}

export function fetchLabourType(categoryId: LabourTypeId) {
  return Endpoint.get<LabourTypeResponse>(`@gc/labour-type/type/${categoryId}`);
}
